module.exports = __webpack_public_path__ + "img/chinesecompany60.a9c743fd.png";